module.exports = __webpack_public_path__ + "media/components/assets/sujung_10-53af8a4fb6c28ace2e7fc3187941c6e0.png";